"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_OutOfTime_OnTickEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const cheekyText = [
    "I'm late! I'm late!",
    "Tick, Tock",
    "I haven't got all day!",
    "When will this end?",
    "Are you coming or going?",
    "Is this the beginning or the end?",
    "How long have I been waiting?"
];
let Effect_OutOfTime_OnTickEventHandlerScript = class Effect_OutOfTime_OnTickEventHandlerScript {
    run(sequence, container, handler, event) {
        const remainingEmissions = handler.schedule.maxEmissions - handler.schedule.emissionCount;
        if (remainingEmissions >= 3) {
            container.applyFloatingText(sequence, event.subject, (0, Random_1.randomElement)(cheekyText), "purple", "large");
            return;
        }
        else if (remainingEmissions === 2) {
            container.applyFloatingText(sequence, event.subject, "Your time is near...", "purple", "large");
            return;
        }
        else if (remainingEmissions === 1) {
            container.applyFloatingText(sequence, event.subject, "In the end...", "purple", "large");
            return;
        }
        container.applyFloatingText(sequence, event.subject, "Time comes for us all...", "purple", "large");
        const enemies = container.selectLivingTargets(event.subject, Target_1.Target.AllEnemies);
        container.applyProjectiles({
            sequence,
            // projectiles travel from victim to caster
            projectiles: enemies.map(targetId => ({
                creatorId: targetId,
                targetId: event.subject,
                jitter: (0, Random_1.random)(25, 75),
                path: "line",
                type: "GreenMagicBall",
            })),
            onProjectile: (sequence, projectile) => {
                container.applyEffect(sequence, 
                // backwards since travelling from target to creator
                projectile.targetId, projectile.creatorId, new core_1.DeathEffectArgs(), Duration_1.Duration.Permanent, true);
            }
        });
    }
};
Effect_OutOfTime_OnTickEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_OutOfTime_OnTick")
], Effect_OutOfTime_OnTickEventHandlerScript);
exports.Effect_OutOfTime_OnTickEventHandlerScript = Effect_OutOfTime_OnTickEventHandlerScript;
